import { Plus, X } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { Select } from '@/components/ui/Select';
import type { TaughtClass } from '../../types/teacher';

interface RecordedClassesHeaderProps {
  currentClass: TaughtClass;
  allocatedClasses?: TaughtClass[];
  selectedClassId?: string;
  onSelectClass?: (id: string) => void;
  isFormOpen: boolean;
  onToggleForm: () => void;
}

export function RecordedClassesHeader({
  currentClass,
  allocatedClasses = [],
  selectedClassId,
  onSelectClass,
  isFormOpen,
  onToggleForm,
}: RecordedClassesHeaderProps) {
  const classOptions = allocatedClasses.map((ac) => ({
    value: ac.id,
    label: `${ac.className} — ${ac.subject} (${ac.role})`,
  }));

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div>
        <h1 className="text-xl sm:text-2xl font-bold text-ink tracking-tight">
          Recorded Classes
        </h1>
        <p className="text-xs sm:text-sm text-ink-3 font-medium mt-1">
          View, manage and share your recorded class sessions.
        </p>
      </div>

      {/* Right Controls: Active Class dropdown + Post a lesson button */}
      <div className="grid grid-cols-1 sm:flex sm:items-center gap-2.5 sm:gap-3 w-full sm:w-auto">
        {allocatedClasses.length > 0 && onSelectClass && (
          <div className="w-full sm:w-60">
            <Select
              label="Active Class"
              options={classOptions}
              value={selectedClassId || currentClass.id}
              onChange={(event) => onSelectClass(event.target.value)}
              className="h-9 text-sm font-semibold"
            />
          </div>
        )}

        <div className="w-full sm:w-auto sm:self-end">
          <Button
            variant={isFormOpen ? 'secondary' : 'primary'}
            size="sm"
            leftIcon={isFormOpen ? <X className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
            onClick={onToggleForm}
            className="h-9 w-full sm:w-auto px-4 text-[14px] font-bold bg-indigo-600 hover:bg-indigo-700 text-white hover:text-white rounded-[10px] shadow-xs"
          >
            {isFormOpen ? 'Close' : 'Post a lesson'}
          </Button>
        </div>
      </div>
    </div>
  );
}
